export default __webpack_public_path__ + "static/media/doubleChan.cbfffe52.jpg";